import { IconButton } from "@material-ui/core";
import { Site } from "@model/site/Site";
import { SearchableTextInput } from "@ui/common/form/SearchableTextInput"
import { DI } from "@ui/DI";
import React, { useEffect } from "react";
import { Button, ButtonTheme, ButtonType } from "./buttons/Button";
import { ImageUrls } from "./images/ImageUrls";
import { set } from "date-fns";

export type SiteSearchCreateProps = {
    onSelectedSiteChanged: (site: Site | null) => void
    selectedSite?: Site | null
    isEnabled?: boolean | null
    /** Outlines the search box in red, matching the required-field treatment on the meter inputs. */
    outlineInvalid?: boolean
}

export function SiteSearchCreate(props: SiteSearchCreateProps): JSX.Element {
    const { onSelectedSiteChanged, selectedSite } = props
    const [isSearchingForSites, setIsSearchingForSites] = React.useState(false)
    const [Sites, SitesChanged] = React.useState<Site[]>([])
    const [availableSites, availableSitesChanged] = React.useState<Site[]>([])
    const companyService = DI.companyService();

    useEffect(() => {
        loadSites();
    }, []);

    async function loadSites() {
        setIsSearchingForSites(true)
        const outcome = await companyService.fetchAllSites()

        if (outcome.isOk()) {
            SitesChanged(outcome.value)
        }

        setIsSearchingForSites(false)
    }


    async function searchSites(search: string) {
        setIsSearchingForSites(true)
        const availableSites = Sites.filter((site) => site.name.toLowerCase().includes(search.toLowerCase()))
        if(availableSites.length == 0 && search.trim() != ""){
            onSelectedSiteChanged({id: 0, name: search} as Site)
        }
        availableSitesChanged(availableSites)
        setIsSearchingForSites(false)
        return availableSites
    }

    return (<>
        <SearchableTextInput
            className={props.outlineInvalid ? "outlineInvalid" : undefined}
            options={availableSites.map((site) => ({
                label: site.name,
                value: site,
                key: site.id,
            }))}
            isLoading={isSearchingForSites}
            isEnabled={props.isEnabled ?? true}
            value={selectedSite?.name ?? ""}
            emptyMessage={"Save Work Order to create"}
            debounceMillis={250}
            onSearchChanged={async (search) => await searchSites(search)}
            onOptionSelected={(option) =>
                onSelectedSiteChanged(option.value)
            }
            allowCreate={true}
            searchOnClick={true}            
        />
        {selectedSite ? <Button
                type={ButtonType.Text}                
                label="Remove"
                onClick={() => { onSelectedSiteChanged(null) }}
                className="site-remove-button"
            /> : <div className="empty-site-remove-button"></div>
        }
        </>
    )
}

